import { render, staticRenderFns } from "./lhArguments.vue?vue&type=template&id=5a741b4d&scoped=true&"
import script from "./lhArguments.vue?vue&type=script&lang=js&"
export * from "./lhArguments.vue?vue&type=script&lang=js&"
import style0 from "./lhArguments.vue?vue&type=style&index=0&id=5a741b4d&lang=less&scoped=true&"
import style1 from "./lhArguments.vue?vue&type=style&index=1&id=5a741b4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a741b4d",
  null
  
)

export default component.exports